import React, {useState} from 'react';
import SDCLogo from '../../../img/SDCLogo.png'
import { useAppDispatch } from "../../../hooks/hooks";
import {Link, useNavigate} from "react-router-dom";
import { setChangePassword, sendConfirmCode } from "../Auth.thunk";
import styles from "./Password.module.scss"
import { toastr } from "react-redux-toastr";
import * as Email from "../../../helpers/email.helper";
import * as Routes from '../../../common/routes';


const Password = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [code, setCode] = useState("");
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState("");

    const setNewPassword = () => {
        if (password !== confirmPassword) {
            return setErrors("Passwords mismatch")
        }
        const payload = {
            email,
            password,
            codeFromEmail: code
        }
        dispatch(setChangePassword(payload))
        setErrors("")
        navigate(Routes.LOGIN)
    }

    const getConfirmCode = async () => {
        if (!Email.Validate(email)) {
            return toastr.error("Auth", "Email should be like example@domain.com")
        }
        dispatch(sendConfirmCode(email));
    }

    return (
        <div className="login-container">
            <div className="login-form">
                <div className="left">
                    <div className="inputs">
                        <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder='E-mail' className="input login"/>
                        <input onChange={(e) => setPassword(e.target.value)} placeholder='New password' className="input login" />
                        <input onChange={(e) => setConfirmPassword(e.target.value)} placeholder='Confirm password' className="input login" />
                        <input onChange={(e) => setCode(e.target.value)} placeholder='Code From Email' className="input login" />
                        <div className={styles.codeBtn}>
                            <button onClick={(e) => { e.preventDefault(); getConfirmCode(); }}> Request confirmation code </button>
                        </div>
                    </div>
                    <button onClick={() => setNewPassword()} type='submit' className="login-btn">Confirm</button>
                    <div className={"password-link"}>
                        <Link className={styles.goToLoginBtn} to={Routes.LOGIN}>Go to login</Link>
                    </div>
                </div>
                <div className="right">
                    <div className="logo">
                        <img className="logo-img" src={SDCLogo} alt="logo"/>
                    </div>
                    <span className="logo-label">Data Collection</span>
                    {
                        errors ? <span className="error">{errors}</span> : <></>
                    }
                </div>
            </div>
        </div>
    );
};

export default Password;
